// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Y5Sn","bigColWidth":"Table_bigColWidth__26h4w","biggerColWidth":"Table_biggerColWidth__SanPL","row":"Table_row__1MM2c","col":"Table_col__2rOwx"};